export const pnkstore = {
  api: { baseurl: 'http://kinshipapi.calleyo.com' },//server
  // api: { baseurl: 'https://www.kinshipliving.com' },//server
  // api: {baseurl:'http://192.168.0.115:3000'},
  // api: { baseurl: 'http://localhost:3000' },
  user: { name: '', password: '', displayName: '', email: '', role: '' },
  app: { mode: 'prod', token: '', startTime: '', lastLoggedTime: '' },
  error: { errorCode: '', errorType: '', errorMessage: '', prettyMessage: '' },
  ajax: { isFetching: false },
  wetherAuthenticated: false,

  loginstatus: false,
  loginusername: '',
  currentUrl:'',

  userlist: {},
  leadlist: {},
  // adminmeetinglist:[],
  //for testing
  name: 'Shiva', age: 1000000,
  wife: { name: 'Mata Sati', age: 900000 },
  daas: [{ name: 'Jai Nandi' }, { name: 'ashu' }, { name: 'prabhash' }, { name: 'sani' }, { name: 'shiva' }, { name: 'anupam' }, { name: 'rajan' }, { name: 'ram' }, { name: 'shweta' }, { name: 'niti&shiv&Kamlesh' }, { name: 'Kailash' }]
};

